import { render, staticRenderFns } from "./RedirectWithPermission.vue?vue&type=template&id=7f3ba318"
import script from "./RedirectWithPermission.vue?vue&type=script&lang=js"
export * from "./RedirectWithPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports